import { render } from "./TnmDepositWebsite.vue?vue&type=template&id=4e3d898e&scoped=true"
import script from "./TnmDepositWebsite.vue?vue&type=script&lang=js"
export * from "./TnmDepositWebsite.vue?vue&type=script&lang=js"

import "./TnmDepositWebsite.vue?vue&type=style&index=0&id=4e3d898e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e3d898e"]])

export default __exports__